import { BCH, BTC, DASH, ETC, ETH, XRP } from "../ui-kit/assets";

export const currencies = {
    BTC: BTC,
    BCH: BCH,
    DASH: DASH,
    ETC: ETC,
    ETH: ETH,
    XRP: XRP,
}
